var _ellipse, _path, _path2, _rect, _path3, _rect2, _rect3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 122,
    viewBox: "0 0 124 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7422,
    cy: 116.5,
    rx: 60,
    ry: 5.5,
    fill: "url(#paint0_radial_40003163_5020)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9457 37.3922C30.5177 41.6869 26.3844 40.2063 24.5999 39.4839C28.8116 42.6802 27.2934 46.0734 26.8599 47.8018C28.3663 43.9501 33.0341 44.8887 35.022 45.6421C31.6995 43.0699 32.363 39.6168 32.9457 37.3922Z",
    fill: "#AA013F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2425 40.0798C84.9416 41.9275 83.2757 41.9427 82.5455 41.9197C84.4645 42.505 84.3692 43.9124 84.4417 44.5847C84.4726 43.0156 86.2577 42.7373 87.0643 42.7446C85.5438 42.2648 85.3269 40.9483 85.2425 40.0798Z",
    fill: "#AA013F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.4609,
    y: 74.1021,
    width: 58.7143,
    height: 42.1776,
    fill: "white",
    stroke: "#AA013F",
    strokeWidth: 1.48409
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1554 116.353C56.0061 114.177 37.6198 87.227 32.8203 74.0239V116.353H91.1554Z",
    fill: "#ECECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0859,
    y: 74.1021,
    width: 11.471,
    height: 42.1776,
    fill: "#AA013F",
    stroke: "#AA013F",
    strokeWidth: 1.48409
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4023,
    y: 61.9771,
    width: 62.5732,
    height: 13.1547,
    transform: "rotate(-0.216493 30.4023 61.9771)",
    fill: "white",
    stroke: "#AA013F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7162 62.0506C52.6428 61.9179 42.8164 59.519 44.0977 50.9846C45.6994 40.3165 59.6315 46.4292 57.7162 62.0506Z",
    stroke: "#AA013F",
    strokeWidth: 4.45228,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8236 61.9567C57.3925 57.6462 57.6453 49.0284 62.1045 49.042C67.6787 49.059 65.9436 61.6177 57.8236 61.9567Z",
    stroke: "#AA013F",
    strokeWidth: 4.45228,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2393 61.8839C62.7987 59.6341 69.3077 55.7276 74.8686 58.0997C81.8198 61.0649 81.9254 60.2732 84.1857 58.2521",
    stroke: "#AA013F",
    strokeWidth: 4.45228,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1602 51.313C37.5701 54.946 40.5237 62.3201 57.058 62.752",
    stroke: "#AA013F",
    strokeWidth: 4.45228,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5097 59.1518C11.5751 55.7573 7.28346 54.2034 4.68919 55.5109C4.68919 55.5109 2.71427 56.1727 1.64062 57.3025L2.72596 58.5449C2.53315 60.4743 3.41688 62.9053 5.30269 65.0873C7.21188 67.2956 9.70683 68.7345 11.9315 69.0973L12.6619 69.9343C12.6619 69.9343 14.501 69.3826 15.6608 68.3879C17.9688 66.6538 17.4838 62.5925 14.5083 59.1505L14.5097 59.1518Z",
    fill: "url(#paint1_linear_40003163_5020)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6779 62.6435C14.8291 66.9106 -1.25236 57.5026 5.30312 65.0879C7.21231 67.2962 9.70726 68.735 11.932 69.0979L12.6623 69.9349C12.6623 69.9349 14.5014 69.3831 15.6612 68.3884C17.5991 66.7265 17.0829 63.4212 16.1749 61.6714L13.6779 62.6435Z",
    fill: "url(#paint2_linear_40003163_5020)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5106 59.1518C14.5091 59.1485 14.1326 58.6137 13.9959 58.6133C13.0628 58.672 10.2734 60.3084 10.2734 60.3084L11.4084 61.8639C13.9444 60.2722 15.2675 60.114 15.2675 60.114C15.2675 60.114 15.0405 59.7252 14.5091 59.1505L14.5106 59.1518Z",
    fill: "url(#paint3_linear_40003163_5020)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5966 69.7111C16.1588 68.0658 15.7337 63.8431 12.6471 60.281C9.5606 56.7189 4.97973 55.165 2.41759 56.8103C-0.146006 58.4556 0.28053 62.6783 3.36707 66.2416C6.45362 69.8037 11.0345 71.3576 13.5966 69.7123V69.7111Z",
    fill: "#FDC530"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8482 67.8209C13.6094 66.6957 13.3172 63.8079 11.1955 61.3718C9.0737 58.9358 5.92471 57.8731 4.16343 58.9983C2.40115 60.1234 2.69436 63.0113 4.81613 65.4482C6.93789 67.8842 10.0869 68.9469 11.8482 67.8218V67.8209Z",
    fill: "#FF9A32"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2607 60.4007C10.1468 60.3132 10.0343 60.2293 9.91744 60.1455C10.1322 60.3457 10.3396 60.5571 10.5383 60.7786C12.6154 63.1446 12.9017 65.9472 11.1781 67.0395C9.86047 67.874 7.75116 67.4711 5.9004 66.1736C5.84343 66.1324 5.78353 66.0911 5.72656 66.046C5.83612 66.1399 5.94568 66.2287 6.05669 66.3163C7.98195 67.8077 10.2782 68.3219 11.6776 67.4348C13.4013 66.3438 13.1135 63.5399 11.0364 61.174C10.7953 60.9037 10.5353 60.646 10.2592 60.4007H10.2607Z",
    fill: "#FDAE30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22316 58.8226H4.21439C2.53016 59.9136 2.80916 62.7088 4.83813 65.0672C5.07039 65.3437 5.32164 65.6077 5.59041 65.8579C5.64592 65.9017 5.69997 65.943 5.75402 65.9856C5.81099 66.0294 5.86796 66.0706 5.92347 66.1132C5.71458 65.913 5.513 65.7028 5.31872 65.4813C3.29121 63.1216 3.01221 60.3265 4.69644 59.2355C5.98482 58.4022 8.04591 58.8039 9.85138 60.0988C9.96532 60.1789 10.0763 60.2627 10.1859 60.3528C8.21828 58.5486 5.70581 57.863 4.2217 58.8239L4.22316 58.8226Z",
    fill: "#B66408"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13521 62.2666C6.04055 62.2985 5.95853 62.2966 5.89122 62.261C5.82812 62.2253 5.78184 62.1746 5.7566 62.1108C5.72925 62.047 5.72714 61.985 5.75028 61.9249C5.77552 61.8592 5.83652 61.8104 5.93118 61.7785L8.54582 60.9038C8.64048 60.8718 8.71831 60.8737 8.78352 60.9113C8.85293 60.9451 8.8992 60.9957 8.92654 61.0596C8.95389 61.1234 8.95389 61.1891 8.92654 61.2548C8.9034 61.3149 8.84451 61.3599 8.74986 61.3918L8.36701 61.5195C8.20293 61.5739 8.062 61.619 7.94631 61.6528C7.83062 61.6865 7.7612 61.7034 7.73596 61.7072L7.74859 61.7353C7.86429 61.7429 7.9905 61.7804 8.12513 61.8442C8.25975 61.908 8.38175 62.0075 8.49113 62.1371L8.99387 61.97C9.08853 61.9381 9.16636 61.94 9.23156 61.9775C9.30098 62.0113 9.34724 62.062 9.37459 62.1258C9.40193 62.1896 9.40193 62.2553 9.37459 62.321C9.35145 62.3811 9.29256 62.4261 9.1979 62.4581L8.73093 62.6139C8.79614 62.8335 8.81297 63.0344 8.78352 63.2164C8.74986 63.3948 8.68675 63.5543 8.58999 63.697C8.49954 63.8378 8.38173 63.9598 8.2387 64.0668C8.09987 64.17 7.95474 64.2564 7.80539 64.3221L10.0288 65.2795C10.136 65.3283 10.2076 65.3977 10.2454 65.4897C10.2812 65.576 10.2833 65.6586 10.2539 65.7375C10.2223 65.8163 10.1571 65.8726 10.0582 65.9045C10.0077 65.9214 9.95094 65.9327 9.89414 65.9365C9.83945 65.9346 9.77426 65.9158 9.70274 65.8839L7.07128 64.7257C6.99976 64.6975 6.94295 64.6637 6.90088 64.6262C6.85671 64.583 6.82306 64.538 6.80202 64.4873C6.76626 64.4009 6.76416 64.3202 6.79781 64.2451C6.82937 64.1663 6.89036 64.1118 6.97871 64.0818L7.07128 64.0518C7.21642 64.003 7.35524 63.9429 7.48776 63.8735C7.62239 63.7965 7.73386 63.7101 7.82221 63.6125C7.91266 63.5093 7.97788 63.3948 8.01785 63.2728C8.05781 63.1489 8.05781 63.0099 8.01995 62.856L6.58536 63.3366C6.4907 63.3685 6.41079 63.3666 6.34137 63.3309C6.27827 63.2953 6.23199 63.2446 6.20464 63.1808C6.1773 63.1169 6.17729 63.055 6.20043 62.9949C6.22567 62.9292 6.28667 62.8804 6.38133 62.8485L7.78015 62.3792C7.49618 62.0357 7.05444 61.9625 6.45705 62.1633L6.13942 62.2703L6.13521 62.2666Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.502 13.8048C113.038 10.0189 112.946 5.71658 110.387 3.929C110.387 3.929 108.81 2.4475 107.095 1.92078L106.172 3.31625C103.94 3.84647 101.606 5.49643 99.9761 7.92955C98.3264 10.3925 97.7831 13.0875 98.3239 15.1575L97.7015 16.097C97.7015 16.097 99.0977 17.4999 100.699 18.1507C103.612 19.5343 107.931 17.6418 110.503 13.8031L110.502 13.8048Z",
    fill: "url(#paint4_linear_40003163_5020)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.057 14.3993C101.836 16.9234 105.449 -0.336044 99.8408 8.04447C98.2084 10.4849 97.6707 13.1552 98.2059 15.2062L97.59 16.1371C97.59 16.1371 98.9716 17.5272 100.556 18.1719C103.203 19.2492 106.631 17.6182 108.179 16.2067L106.057 14.3993Z",
    fill: "url(#paint5_linear_40003163_5020)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.443 13.6357C110.446 13.6333 110.878 13.1159 110.821 12.9977C110.363 12.2124 107.383 10.3892 107.383 10.3892L106.143 11.9282C108.968 13.5485 109.699 14.6352 109.699 14.6352C109.699 14.6352 110.033 14.2995 110.444 13.634L110.443 13.6357Z",
    fill: "url(#paint6_linear_40003163_5020)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.36 16.8992C101.283 18.5372 105.81 16.6377 108.469 12.6572C111.128 8.67664 110.913 4.12043 107.99 2.48247C105.066 0.843235 100.54 2.74397 97.8799 6.72496C95.2209 10.7055 95.4356 15.2617 98.3586 16.8997L98.36 16.8992Z",
    fill: "#FFDF50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7196 14.6905C101.722 15.8184 104.817 14.5183 106.631 11.7868C108.444 9.05543 108.291 5.92575 106.288 4.79781C104.285 3.66899 101.191 4.97003 99.376 7.70175C97.5623 10.4332 97.716 13.5628 99.7187 14.6908L99.7196 14.6905Z",
    fill: "#FEBD00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.738 11.1336C106.788 11.0022 106.833 10.8734 106.877 10.7409C106.745 11.0012 106.597 11.2593 106.434 11.5133C104.675 14.1879 101.666 15.4555 99.711 14.3454C98.2172 13.4966 97.7688 11.5067 98.4301 9.41791C98.452 9.35313 98.4726 9.28578 98.4986 9.21963C98.4405 9.34946 98.3879 9.47747 98.3373 9.6063C97.491 11.8306 97.8947 14.0244 99.4821 14.9256C101.435 16.0362 104.446 14.7668 106.205 12.0923C106.404 11.7835 106.581 11.4626 106.738 11.1323L106.738 11.1336Z",
    fill: "#B66408"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.498 4.58047L106.494 4.5725C104.53 3.43671 101.533 4.70409 99.7991 7.40435C99.5933 7.71582 99.4099 8.04003 99.2497 8.37517C99.2254 8.44153 99.2033 8.50565 99.1797 8.57022C99.1561 8.6379 99.1353 8.70468 99.1124 8.77058C99.2433 8.50804 99.3886 8.24851 99.5497 7.99154C101.286 5.29216 104.282 4.02477 106.247 5.16056C107.748 6.02987 108.214 8.04967 107.568 10.161C107.529 10.2937 107.485 10.425 107.433 10.5573C108.575 8.11384 108.227 5.58061 106.496 4.5796L106.498 4.58047Z",
    fill: "#B66408"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.354 7.4855C103.281 7.41563 103.249 7.34505 103.258 7.27553C103.27 7.2096 103.303 7.15291 103.36 7.10969C103.415 7.06468 103.479 7.04182 103.551 7.04114C103.631 7.04033 103.707 7.07575 103.78 7.14562L105.782 9.07785C105.855 9.14772 105.885 9.21472 105.873 9.28309C105.866 9.35376 105.832 9.41044 105.777 9.45545C105.722 9.50046 105.653 9.5228 105.573 9.52181C105.5 9.5225 105.429 9.48759 105.356 9.41773L105.063 9.13465C104.938 9.01325 104.832 8.90838 104.749 8.82121C104.666 8.73405 104.619 8.6806 104.605 8.66035L104.58 8.68069C104.621 8.7819 104.634 8.90229 104.623 9.03878C104.612 9.17527 104.559 9.31312 104.469 9.45041L104.852 9.82232C104.925 9.89219 104.956 9.9592 104.943 10.0276C104.937 10.0982 104.903 10.1549 104.848 10.1999C104.792 10.2449 104.723 10.2673 104.643 10.2663C104.571 10.267 104.499 10.2321 104.427 10.1622L104.069 9.81696C103.867 9.94722 103.664 10.0298 103.461 10.0666C103.26 10.0985 103.067 10.099 102.878 10.0649C102.693 10.0357 102.516 9.97668 102.345 9.89108C102.179 9.80779 102.028 9.71339 101.897 9.60837L101.82 11.8297C101.813 11.9378 101.77 12.0224 101.69 12.0859C101.614 12.1458 101.529 12.1756 101.434 12.1773C101.339 12.1772 101.252 12.1407 101.178 12.0673C101.139 12.03 101.104 11.9854 101.076 11.9382C101.056 11.8909 101.048 11.829 101.052 11.7571L101.17 9.11956C101.17 9.049 101.181 8.98907 101.203 8.94044C101.23 8.8881 101.263 8.84409 101.308 8.80893C101.383 8.74908 101.467 8.71985 101.559 8.72303C101.655 8.72313 101.737 8.75664 101.805 8.82177L101.875 8.89049C101.987 8.99767 102.107 9.09563 102.235 9.18503C102.371 9.27366 102.508 9.33937 102.647 9.38152C102.792 9.42356 102.939 9.44025 103.084 9.43286C103.23 9.42483 103.375 9.37761 103.521 9.29301L102.421 8.23304C102.349 8.16317 102.317 8.09439 102.326 8.02308C102.337 7.95714 102.371 7.90045 102.426 7.85544C102.482 7.81043 102.546 7.78937 102.619 7.78868C102.698 7.78787 102.775 7.8233 102.847 7.89316L103.92 8.92646C104.161 8.56754 104.054 8.16598 103.596 7.72484L103.352 7.49037L103.354 7.4855Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.319 34.4279L120.34 33.3702L113.246 43.8737L115.225 44.9314C116.094 45.3661 118.391 43.3662 120.349 40.4663C122.306 37.5665 123.189 34.8628 122.319 34.4279Z",
    fill: "url(#paint7_linear_40003163_5020)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.319 34.4279L120.34 33.3702L113.246 43.8737L115.225 44.9314C116.094 45.3661 118.391 43.3662 120.349 40.4663C122.306 37.5665 123.189 34.8628 122.319 34.4279Z",
    fill: "url(#paint8_linear_40003163_5020)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.681 39.654C120.683 39.6522 121.03 39.2813 120.996 39.203C120.711 38.6862 118.655 37.5658 118.655 37.5658L117.658 38.6671C119.613 39.6555 120.078 40.3666 120.078 40.3666C120.078 40.3666 120.342 40.1237 120.682 39.6528L120.681 39.654Z",
    fill: "url(#paint9_linear_40003163_5020)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M121.955 37.842C121.686 37.3198 119.827 36.6279 119.827 36.6279L119.378 37.0745C120.86 37.4518 121.69 38.3208 121.69 38.3208C121.97 38.0356 121.955 37.842 121.955 37.842Z",
    fill: "url(#paint10_linear_40003163_5020)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M118.322 39.406C120.248 36.5152 121.114 33.8191 120.256 33.3833C119.397 32.9482 117.14 34.938 115.214 37.8288C113.287 40.7195 112.421 43.4156 113.28 43.8508C114.138 44.2859 116.395 42.2961 118.322 39.4054L118.322 39.406Z",
    fill: "#FDC530"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.312 38.3916C118.359 38.3052 118.406 38.2195 118.453 38.1345C118.344 38.3131 118.229 38.4937 118.107 38.6752C116.825 40.5844 115.322 41.8948 114.752 41.611C114.316 41.3916 114.553 40.2983 115.257 38.9443L115.326 38.814C115.276 38.901 115.227 38.9875 115.18 39.0725C114.367 40.5451 114.074 41.7627 114.538 41.9969C115.108 42.2841 116.611 40.9697 117.893 39.0613C118.041 38.8357 118.181 38.6129 118.311 38.392L118.312 38.3916Z",
    fill: "#B66408"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.187 35.1449C118.618 34.8706 117.11 36.1546 115.817 38.011C115.664 38.2318 115.521 38.4489 115.389 38.6629L115.317 38.7864L115.246 38.9133C115.356 38.74 115.473 38.5642 115.595 38.3865C116.888 36.5301 118.397 35.2502 118.965 35.5204C119.399 35.7302 119.154 36.7899 118.442 38.1057C118.398 38.1875 118.352 38.2713 118.3 38.3561C119.291 36.7578 119.687 35.3871 119.186 35.1455L119.187 35.1449Z",
    fill: "#B66408"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.797 35.4353C118.232 35.1482 116.75 36.4588 115.487 38.3636C115.367 38.5457 115.253 38.7259 115.146 38.9044C114.449 40.2566 114.222 41.3466 114.65 41.5668C115.215 41.8551 116.698 40.5473 117.961 38.6386C118.082 38.4573 118.195 38.2769 118.302 38.0986C119 36.7464 119.229 35.6558 118.798 35.4356L118.797 35.4353Z",
    fill: "#FF9A32"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.753 37.2079L117.976 37.181L118.495 36.5848L117.338 36.7195L116.817 37.3198L117.437 37.2453C117.406 37.3634 117.336 37.5599 117.186 37.8164L116.902 37.8496L116.38 38.4505L116.76 38.4044C116.76 38.4044 116.758 38.4078 116.756 38.4093C116.087 39.188 115.806 39.062 115.806 39.062L115.535 40.8421L115.951 40.6309L116.169 39.3025C116.169 39.3025 116.531 39.0727 117.063 38.3681L117.541 38.3107L118.06 37.7145L117.464 37.7839C117.606 37.5495 117.697 37.357 117.754 37.207L117.753 37.2079Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40003163_5020",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.7422 116.5) scale(60 5.5)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40003163_5020",
    x1: 0.787553,
    y1: 60.8759,
    x2: 17.3401,
    y2: 64.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B05E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40003163_5020",
    x1: 0.787983,
    y1: 60.8778,
    x2: 17.3405,
    y2: 64.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA013F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40003163_5020",
    x1: 14.3593,
    y1: 59.3363,
    x2: 12.6663,
    y2: 60.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40003163_5020",
    x1: 102.751,
    y1: 2.47063,
    x2: 104.765,
    y2: 18.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B05E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40003163_5020",
    x1: 102.585,
    y1: 2.63607,
    x2: 104.583,
    y2: 18.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA013F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40003163_5020",
    x1: 110.175,
    y1: 13.5712,
    x2: 108.714,
    y2: 12.1186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40003163_5020",
    x1: 113.925,
    y1: 40.3585,
    x2: 122.74,
    y2: 37.7871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B05E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40003163_5020",
    x1: 113.925,
    y1: 40.3585,
    x2: 122.74,
    y2: 37.7871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B05E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40003163_5020",
    x1: 120.49,
    y1: 39.621,
    x2: 119.58,
    y2: 38.6325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_40003163_5020",
    x1: 122.095,
    y1: 37.8509,
    x2: 121.262,
    y2: 36.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B76508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1C2",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.557c5e38cee0bbe8b6511f7d427af743.svg";
export { ForwardRef as ReactComponent };